import { Expose } from 'class-transformer';
import { BaseModel } from '@lib/common-sdk';

export class CommuneModel extends BaseModel {
  @Expose()
  name?: string;
  @Expose()
  province?: string;
}
